import { getProfileData } from 'data/DataStore';
import flags from "featureFlags";

export function isOtsEnabled() {
	return flags.onTheShelf() && !!getProfileData().OnTheShelfProfileGuid;			
}



// WEBPACK FOOTER //
// ./src/data/FeatureCheck.js